import { environment } from '@dxp/core/environment';

const getColourValue = (key: string): string => {
    return getComputedStyle(document.documentElement).getPropertyValue(key);
};

export const getColours = (): Record<string, string> => ({
    danger: getColourValue('--red-primary'),
    warning: getColourValue('--yellow-primary'),
    success: getColourValue('--green-primary'),
    dark: getColourValue('--dark-primary'),
    socials: getColourValue('--purple-primary'),
    webchat: getColourValue('--webchat-primary'),
    email: getColourValue('--email-primary'),
    primary: getColourValue('--blue-primary'),
    background: getColourValue('--background'),
});

export const DisplayTypes = [
    'app',
    'dashboard',
    'performance',
    'communication',
    'contacts',
] as const;
export type DisplayType = (typeof DisplayTypes)[number];

export const ViewTypes = ['standard', 'expanded', 'settings'] as const;
export type ViewType = (typeof ViewTypes)[number];

export const recalculateHeight = (
    view: DisplayType,
    display: ViewType,
    offset = '0px',
): string => {
    return `calc(100vh - ${environment.resize[view][display]}px - ${offset})`;
};
